import React from 'react'
import { FieldValues, UseFormReturn } from 'react-hook-form'

type ContextValue<FV extends FieldValues = any, TContext = any> = Partial<UseFormReturn<FV, TContext>>

const FormContext = React.createContext<ContextValue>({})

export { FormContext }
